exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".incorporacionAbandono {\n  margin: 20px 0;\n}\n.incorporacionAbandono .alert-danger {\n  display: block !important;\n  word-wrap: break-word;\n}\n.incorporacionAbandono button {\n  background: var(--gris-oscuro);\n  color: #ffffff;\n  border: 0;\n  outline: 0;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 6px 18px;\n  font-weight: 700;\n  border-radius: 10px;\n  min-height: 20px;\n  text-transform: capitalize;\n}\n.incorporacionAbandono button:disabled {\n  color: var(--gris-oscuro);\n  background: var(--gris-claro);\n}", ""]);

// exports
